import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState, ICenterListResponse, IRecipientForTransplantedList } from "../";

export interface IChangeStatusRequest {
    eventId: number,
    eventType: number,
    transplantDate: string,
    isNkrTansplant: boolean,
    nkrRecipientId?: number,
    hasMedicare?: boolean,
    donorOriginType?: number,
    donorOriginOther: string,
    isDonorFound: boolean,
    dashRegistrationId?: number,
    comment: string,
    newCenterId?: number,
    newCoordinatorId?: number,
    isNkrCenter: boolean,
    contactDate?: string,
    contactMethod?: number,
    isCoachOptIn?: boolean,
    deactivateMicrosite?: boolean
}

export interface IChangeStatusResponse {
    data: {
        success: boolean,
        message: string,
        results: IRecipientForTransplantedList
    }
}

export enum BulkChangeStatusOutcome {
    Updated = 0,
    Skipped = 1,
    Failed = 2
}

export interface IBulkChangeStatusResult {
    micrositeId: number,
    patientName: string,
    outcome: BulkChangeStatusOutcome,
    message: string
}

export interface IBulkChangeStatusResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            updatedCount: number,
            skippedCount: number,
            failedCount: number,
            items: IBulkChangeStatusResult[]
        }
    }
}

export const ActionCreators = {
    changeStatus: (micrositeId: number, request: IChangeStatusRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<IChangeStatusResponse> => {
        let options = {
            url: `${__API__}/microsite/${micrositeId}/change-status`,
            data: request
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    bulkChangeStatus: (micrositeIds: number[], request: IChangeStatusRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<IBulkChangeStatusResponse> => {
        let options = {
            url: `${__API__}/microsite/bulk-change-status`,
            data: { micrositeIds, request }
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    getCenterList: () => (dispatch: Dispatch<IApplicationState>): Promise<ICenterListResponse> => {
        let options = {
            url: __API__ + "/microsite/centers-for-transfer"
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: ICenterListResponse) => {
            if (response.data.success)
                // dispatch(ActionCreators.setCenterList(response.data.results));

                return Promise.resolve(response);
        });
    },
}